<template>
  <b-container class="post-images-container">
    <h3 class="title-text">Gallery Archive</h3>
    <p class="title-second-text">Here you can find all the previous
      {{ $route.params.isEvent ? 'event' : 'award' }}'s galleries
    </p>
    <gallery
      :images="showImages"
      :index="index"
      @close="index = null"
    />
    <div class="functional-row">
      <button class="btn mb-1"
        @click="$router.go(-1)"
      > <b>&#60;</b> Back</button>
      <!-- <div class="filterArea">
        <label for="" class="searchArea">
          <input type="text" >
          <i class="fas fa-search"></i>
        </label>
        <div
          @click="filterByYear()"
          class="ml-2" :class="{active: activeClass === 'year'}"
        >Year <i class="fas fa-chevron-down mr-2"></i></div>
        <div
          @click="filterByEvent()"
          :class="{active: activeClass === 'event'}"
          >Event <i class="fas fa-chevron-down mr-2"></i>
        </div>
      </div> -->
    </div>
    <div class="mb-4">
      <div v-if="!showImages.length" class="text-for-empty">There is no image to show.</div>
      <viewer v-else :images="showImages" :options="options" class="images clearfix multiple-images">
        <template slot-scope="scope">
          <img
            v-for="{ id, image } in scope.images"
            :key="id"
            class="event-high-img"
            :src="image"
            title="id"
          />
        </template>
      </viewer>
    </div>
  </b-container>
</template>


<script>
import VueGallery from 'vue-gallery';
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    images: {
      type: Array,
      default: () => [],
    },
  },
  name: 'ImageGallery',
  components: {
    gallery: VueGallery,
  },
  data() {
    return {
      index: 0,
      activeClass: null,
      showImages: [],
      options: {
        title: true,
        scalable: false,
        rotatable: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      prevEvent: 'events/prevEvent',
    }),
  },
  methods: {
    ...mapActions({
      eventGallery: 'events/fetchGallery',
      awardGallery: 'awards/fetchGallery',
    }),
    // to do
    filterByEvent() {
      this.activeClass = 'event';
      // this.images = this.images.sort((a, b) => ((a.event > b.event) ? 1 : -1));
    },
    // to do
    filterByYear() {
      this.activeClass = 'year';
      // this.images = this.images.sort((a, b) => ((a.year > b.year) ? 1 : -1));
    },
    openImage(id) {
      this.index = id;
    },
    // findImage(value) {
    // const images = [...this.images];
    // if (this.searchInput) {
    //   const filtered = images.filter(video => video.name.includes(this.searchInput));
    //   return filtered;
    // }
    // return this.images;
    // },
  },
  watch: {
    searchInput: {
      // handler(value) {
      //   this.findImage(value);
      // },
    },
  },
  async mounted() {
    if (this.prevEvent.id) {
      if (this.$route.params.isEvent) {
        this.showImages = await this.eventGallery(this.prevEvent.id);
      } else {
        this.showImages = await this.awardGallery(this.prevEvent.id);
      }
    }
  },
};
</script>
<style src="./PrevEditionStyles.css" scoped></style>
